import PropTypes from 'prop-types';
import {CreateUpdateEntityDialog} from '@ozgene/gp5.components.create-update-entity-dialog';
import StepConsumableEditor from 'Consumables/components/StepConsumableEditor';

export default function CreateUpdateStepConsumableDialog(props) {
  const {onClose, onSave, entity} = props;
  const getEntityLabel = ({
    consumable: {name: consumableName},
    metricUnit: {name: unitName},
    quantity,
  }) => `${consumableName} -- ${quantity}${unitName}`;

  return (
    <CreateUpdateEntityDialog
      getEntityLabel={getEntityLabel}
      entityType="Step Consumable"
      EditorComponent={StepConsumableEditor}
      onSave={onSave}
      onClose={onClose}
      entity={entity}
    />
  );
}

CreateUpdateStepConsumableDialog.propTypes = {
  entity: PropTypes.shape({
    consumable: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      productCode: PropTypes.string,
      supplier: PropTypes.string,
    }),
    metricUnit: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }),
    quantity: PropTypes.number,
  }),
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

CreateUpdateStepConsumableDialog.contextTypes = {
  router: PropTypes.object.isRequired,
};

CreateUpdateStepConsumableDialog.defaultProps = {
  entity: null,
};
